
export default function AboutTeam() {
  const teamMembers = [
    {
      name: 'Sarah Chen',
      role: 'Chief Executive Officer',
      bio: 'Former McKinsey partner with 15+ years in strategy consulting. Led digital transformations for Fortune 500 companies.',
      image: 'https://public.readdy.ai/ai/img_res/b5f5561de6cacc99a53e7a44c706fb6d.jpg',
      linkedin: '#'
    },
    {
      name: 'Marcus Rodriguez',
      role: 'Chief Technology Officer',
      bio: 'Serial entrepreneur and tech innovator. Previously founded two successful SaaS companies acquired by major tech firms.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20male%20technology%20executive%20CTO%20in%20business%20casual%20attire%20with%20friendly%20expression%20in%20modern%20tech%20office%20environment%2C%20corporate%20headshot%20with%20clean%20background&width=400&height=400&seq=cto-marcus&orientation=squarish',
      linkedin: '#'
    },
    {
      name: 'Emily Thompson',
      role: 'Head of Programs',
      bio: 'Expert in business development and accelerator programs. Former director at Techstars with 200+ successful startups mentored.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20businesswoman%20program%20director%20in%20professional%20blazer%20with%20warm%20smile%20in%20contemporary%20office%20space%2C%20executive%20portrait%20with%20soft%20lighting%20and%20modern%20background&width=400&height=400&seq=programs-emily&orientation=squarish',
      linkedin: '#'
    },
    {
      name: 'David Kim',
      role: 'Head of Partnerships',
      bio: 'Strategic partnerships expert with extensive network in venture capital and corporate innovation. MBA from Stanford.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20businessman%20partnerships%20executive%20in%20sharp%20business%20suit%20with%20confident%20demeanor%20in%20upscale%20office%20environment%2C%20corporate%20headshot%20with%20professional%20lighting&width=400&height=400&seq=partnerships-david&orientation=squarish',
      linkedin: '#'
    },
    {
      name: 'Lisa Patel',
      role: 'Head of Community',
      bio: 'Community building specialist with passion for connecting entrepreneurs globally. Former head of community at Y Combinator.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20businesswoman%20community%20leader%20in%20stylish%20business%20attire%20with%20engaging%20smile%20in%20vibrant%20office%20setting%2C%20executive%20portrait%20with%20warm%20lighting%20and%20modern%20workspace%20background&width=400&height=400&seq=community-lisa&orientation=squarish',
      linkedin: '#'
    },
    {
      name: 'James Wilson',
      role: 'Head of Operations',
      bio: 'Operations excellence leader with background in scaling global organizations. Former VP Operations at Uber.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20businessman%20operations%20executive%20in%20crisp%20business%20shirt%20with%20approachable%20expression%20in%20sleek%20office%20environment%2C%20corporate%20headshot%20with%20clean%20professional%20background&width=400&height=400&seq=operations-james&orientation=squarish',
      linkedin: '#'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Meet Our Leadership Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our diverse team of industry experts and visionary leaders is dedicated to empowering businesses worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{member.bio}</p>
                <a
                  href={member.linkedin}
                  className="inline-flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg mr-2"></i>
                  Connect on LinkedIn
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
